import { Avatar, Tooltip } from "@atoms"

import { UserAvatar, UserAvatarStack } from "@molecules"

import { AssigneesBadgeProps } from "./AssigneesBadge.types"

export default function AssigneesBadge(props: AssigneesBadgeProps) {
    const { technicians, limit = 3 } = props

    if (technicians.length === 0) {
        return (
            <Tooltip body="Unassigned" defaultPlacement="bottom">
                <Avatar variant="user-placeholder" size="sm" />
            </Tooltip>
        )
    } else if (technicians.length === 1) {
        const user = technicians[0]

        return (
            <Tooltip body={user.full_name} defaultPlacement="bottom">
                <UserAvatar user={user} size="sm" />
            </Tooltip>
        )
    } else {
        return (
            <UserAvatarStack
                users={technicians}
                limit={limit}
                avatarSize="sm"
                variation="inline"
                tooltipPlacement="bottom"
            />
        )
    }
}
